import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { ReleaseVersionAudioData } from 'types/releases';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getReleaseVersion } from 'app/store/Releases/selectors';
import { fetchReleaseVersionSongAudioListEffect } from 'app/store/Releases/effects';
import { fetchSongEffect } from 'app/store/SongList/effects';
import { ValidationContext } from 'app/components/Audio';

export const useFetchAudioDependencies = (
  setAudioData: Dispatch<SetStateAction<ReleaseVersionAudioData>>,
  options?: { validationContext?: ValidationContext }
) => {
  const dispatch = useAppDispatch();
  const [audioDataLoading, setAudioDataLoading] = useState(false);
  const releaseVersion = useAppSelector(getReleaseVersion);

  const fetchAudioDependencies = useCallback(async () => {
    try {
      setAudioDataLoading(true);
      const items = await dispatch(
        fetchReleaseVersionSongAudioListEffect({ ...options })
      ).unwrap();
      const song = await dispatch(
        fetchSongEffect({ guid: releaseVersion?.song.songGuid || '' })
      ).unwrap();
      setAudioData({ items, latestAudioGuid: song.latestVersionAudio });
      setAudioDataLoading(false);
    } catch {
      // proceed
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseVersion?.song.songGuid]);

  useEffect(() => {
    if (releaseVersion?.metadata.guid) {
      fetchAudioDependencies();
    }
  }, [fetchAudioDependencies, releaseVersion?.metadata.guid]);

  return { audioDataLoading };
};
